export { AdditionalInfo } from './AdditionalInfo';
export { AdditionalInfoSeverity } from './AdditionalInfo.types';
